/****************************************************************************
 * Copyright 2021 EPAM Systems
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ***************************************************************************/

export const PeptideAvatar = () => (
  <>
    <symbol id="peptide" viewBox="0 0 70 61" width="70" height="61">
      <path
        className="monomer-body"
        transform="scale(0.5)"
        data-actual-width="35"
        data-actual-height="30.5"
        d="M16.9236 1.00466C17.2801 0.383231 17.9418 6.10888e-07 18.6583 5.98224e-07L51.3417 2.04752e-08C52.0582 7.81036e-09 52.7199 0.383234 53.0764 1.00466L69.4289 29.5047C69.7826 30.1211 69.7826 30.8789 69.4289 31.4953L53.0764 59.9953C52.7199 60.6168 52.0582 61 51.3417 61H18.6583C17.9418 61 17.2801 60.6168 16.9236 59.9953L0.571095 31.4953C0.217407 30.8789 0.217408 30.1211 0.571096 29.5047L16.9236 1.00466Z"
      ></path>
    </symbol>
    <symbol id="peptide-hover" viewBox="0 0 70 61" width="70" height="61">
      <path
        d="M18.2246 1.75116C18.3137 1.59581 18.4792 1.5 18.6583 1.5L51.3417 1.5C51.5208 1.5 51.6863 1.59581 51.7754 1.75116L53.06 1.01408L51.7754 1.75117L68.1279 30.2512C68.2163 30.4053 68.2163 30.5947 68.1279 30.7488L51.7754 59.2488C51.6863 59.4042 51.5208 59.5 51.3417 59.5H18.6583C18.4792 59.5 18.3137 59.4042 18.2246 59.2488L1.87215 30.7488C1.78372 30.5947 1.78372 30.4053 1.87215 30.2512L18.2246 1.75116Z"
        fill="none"
        transform="scale(0.5)"
        stroke="#0097A8"
        strokeWidth="3"
      />{' '}
    </symbol>
    <symbol
      id="modified-background"
      viewBox="0 0 60 20"
      width="30"
      height="20"
      x="2.5"
      y="5"
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M6.52702 20C5.81057 20 5.14885 19.6168 4.79229 18.9953L0.570974 11.6382C0.217285 11.0218 
           0.217285 10.2639 0.570974 9.64751L5.52999 1.00466C5.88654 0.383235 6.54827 0 7.26472 0H52.735C53.4515
           0 54.1132 0.383234 54.4698 1.00466L59.4288 9.64751C59.7825 10.2639 59.7825 11.0218 59.4288 11.6382
           L55.2075 18.9953C54.8509 19.6168 54.1892 20 53.4727 20H6.52702Z"
        fillOpacity="0.6"
      />
    </symbol>
    <symbol
      id="peptide-autochain-preview"
      viewBox="0 0 37 32"
      width="37"
      height="32"
      data-actual-width="37"
      data-actual-height="32"
    >
      <path d="M8.27143 3.53027L9.29272 1.77462C9.65083 1.15901 10.3093 0.780274 11.0215 0.780274L13.1642 0.780274M29.2131 3.53027L28.1919 1.77462C27.8337 1.15901 27.1753 0.780273 26.4631 0.780273L24.3164 0.780273M2.45429 13.5303L1.585 15.0246C1.22337 15.6463 1.22337 16.4143 1.585 17.0359L2.45429 18.5303M29.0386 28.5303L28.0233 30.2756C27.6619 30.897 26.991 31.2803 26.2646 31.2803L24.1459 31.2803M8.09693 28.5303L9.11221 30.2756C9.47371 30.897 10.1446 31.2803 10.871 31.2803H12.9936M34.8558 18.5303L35.7311 17.0256C36.0896 16.4092 36.0896 15.6514 35.7311 15.0349L34.8558 13.5303" />
      <path d="M14.8937 0.780178L17.8937 0.780178" />
      <path d="M19.597 0.780178L22.597 0.780178" />
      <path d="M14.8937 31.2804H17.8937" />
      <path d="M19.597 31.2804H22.597" />
      <path d="M3.61253 11.7412L5.11253 9.14309" />
      <path d="M5.96421 7.66792L7.46421 5.06984" />
      <path d="M30.1034 26.877L31.6034 24.2789" />
      <path d="M32.455 22.8038L33.955 20.2057" />
      <path d="M7.32633 26.9903L5.82633 24.3922" />
      <path d="M4.97465 22.917L3.47465 20.319" />
      <path d="M33.9528 11.8759L32.4782 9.26339" />
      <path d="M31.6409 7.78023L30.1662 5.16769" />
    </symbol>
  </>
);
